import React, { useEffect } from 'react';
import { useNavigate } from "react-router-dom";

/* This function will make sure that protected routes can't be accessed without authorization */ 

export const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (sessionStorage.getItem("userAuthorization") === null){
      navigate('/', {replace: true});
    }
  }, [])
  
  return children;
};